import { useEffect, useState } from "react";
import { Identifiable } from "../../model/Items";
import DetailsDialog, { DetailsProps } from "../DetailsDialog";
import { SpringMaterial } from "../../api/SpringMaterialApi";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import NumberInputField from "../ui/NumberInputField";

interface SpringMaterialPrice {
  material: Identifiable;
  unitPrice: number;
}

interface Properties
extends DetailsProps {
  customerId: number;
  priceListId: number;
  fetchSpringMaterials: () => Promise<SpringMaterial[]>;
}
const sortByName = (material: SpringMaterial, anotherMaterial: SpringMaterial) => material.name.localeCompare(anotherMaterial.name);

const SpringMaterialPriceDetails = (properties: Properties) => {
  const customerId = properties.customerId;
  const priceListId = properties.priceListId;
  const fetchSpringMaterials = properties.fetchSpringMaterials;
  const [materials, setMaterials] = useState<SpringMaterial[]>();
  const [selectedMaterial, setSelectedMaterial] = useState<Identifiable>();
  const [unitPrice, setUnitPrice] = useState<number>();

  const initializeFields = (data: SpringMaterialPrice) => {
    setSelectedMaterial({ id: data.material.id })
    setUnitPrice(data.unitPrice);
  };

  const collectData = (): SpringMaterialPrice|null =>
    (selectedMaterial && unitPrice)
      ? {
        material: { id: selectedMaterial.id },
        unitPrice,
      }
      : null;

  const handleMaterialChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedMaterial = event.target.value as Identifiable;
    setSelectedMaterial(selectedMaterial);
  };

  const renderFields = (initialData: SpringMaterialPrice|undefined) => (
    <>
      <h2>Wprowadź cenę sprężyny</h2>
      { materials && <FormControl>
        <InputLabel>Materiał</InputLabel>
        <Select value={selectedMaterial || null} onChange={ handleMaterialChange }>
          { materials.map(material => (<MenuItem value={material as any}>{material.name} ({material.thickness} mm)</MenuItem>)) }
        </Select>
      </FormControl> }
      <NumberInputField
        label='Cena jednostkowa'
        autoFocus
        initialValue={initialData?.unitPrice}
        onValueChange={setUnitPrice} />
    </>
  );

  const fetchMaterialsAndSortByName = () => {
    fetchSpringMaterials()
      .then(data => setMaterials(data.sort(sortByName)))
      .catch(reason => console.error(`Could not fetch spring materials: ${reason}`));
  };

  useEffect(fetchMaterialsAndSortByName, []);

  useEffect(() => {
    if (materials && selectedMaterial) {
      setSelectedMaterial(materials.find(material => material.id === selectedMaterial.id));
    }
  }, [materials, selectedMaterial]);

  return (
    <DetailsDialog<SpringMaterialPrice>
      { ...properties }
      resource={`customers/${customerId}/price-lists/${priceListId}/spring-material-prices`}
      renderFields={ renderFields }
      initializeFields={ initializeFields }
      collectData={ collectData }
    />
  );
};

export default SpringMaterialPriceDetails;